import { ApiSlugs, UserDto, UserId } from '@workspace/data-types';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';
import { UserInternationalizationConnector } from './internationalization/user-internationalization.connector';
import { UserNotificationsConnector } from './notifications/user-notifications.connector';

export class UserSettingsConnector extends ApiConnector<UserDto, UserDto, UserId> {
  constructor(apiCaller: ApiCaller, slug: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${slug}/${ApiSlugs.SETTINGS}`);
  }

  internationalization = () =>
    new UserInternationalizationConnector(this.apiCaller, this.slug, this.apiPrefix);

  notifications = () => new UserNotificationsConnector(this.apiCaller, this.slug, this.apiPrefix);
}
